import { useTheme } from "@mui/material/styles";

import createAvatar from "../utils/createAvatar";
import Avatar, { Props as AvatarProps } from "./Avatar";
import { RootState, useSelector } from "@redux/store";
import { CustomTheme } from "src/@types/customTheme";

export default function MyAvatar({
  user,
  ...other
}: AvatarProps & { user?: any }) {
  const theme = useTheme();
  const customTheme = useSelector(
    (state: RootState) => state.accountInfo.accountInfo?.customTheme,
  );

  return (
    <Avatar
      src={user?.photoURL}
      alt={user?.firstName}
      customColor={
        customTheme === CustomTheme.Sage
          ? theme.palette.sage_green
          : user?.photoURL
          ? "default"
          : createAvatar(user?.firstName).customColor
      }
      {...other}
      sx={customTheme === CustomTheme.Sage ? { color: theme.palette.common.white } : undefined}
    >
      {createAvatar(user?.firstName).name}
    </Avatar>
  );
}
